<template>
  <div class="error403">
    <div class="error403__wrapper">
      <p class="error403__message">
        Your account has been expired.
        <br>
        Please contact support to continue your subscription
      </p>
    </div>

    <div class="error403__bottom">
      SATOSHI EYE © {{ getFullYear }} ALL RIGHTS RESERVED
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error403',
  computed: {
    getFullYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style scoped>
.error403 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 100vh;
  background-color: var(--white);
  padding: 40px 20px 24px;
  box-sizing: border-box;
}

.error403__wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.error403__title {
  font-weight: 700;
  font-size: 64px;
  margin: 0 0 16px;
  color: var(--Texts-General-Primary);
}

.error403__message {
  font-size: 18px;
  line-height: 1.5;
  color: var(--Texts-General-Secondary);
  margin-bottom: 32px;
  max-width: 550px;
}

.error403__button {
  min-width: 200px;
  text-transform: uppercase;
  cursor: pointer;
}

.error403__bottom {
  font-weight: 500;
  font-size: 12px;
  color: var(--Texts-General-Secondary);
  text-align: center;
  margin-top: 24px;
}
</style>
